import React from 'react'
import { db } from './firebase'
import { setForm } from './redux/reducers'
import { connect } from 'react-redux'
// import MaskedInput from 'react-text-mask'
// import { makeTelMask, isDateValid } from './common'
import FormPage1 from './FormPage1'
import FormPage2 from './FormPage2'
import FormPage3 from './FormPage3'
import FormPage4 from './FormPage4'
import FormPage5 from './FormPage5'
import FormPageDone from './FormPageDone'
import logo from './logo.png'

// import Steps from 'react-step-progress'
// import 'react-step-progress/dist/index.css'

import Steps from 'rc-steps'
import 'rc-steps/assets/index.css'

import { history } from './history'

export class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // formData: {...this.props.location.state},
      indicacaoText: 'Quem?',
      error: null,
      loading: false,
      loadingMessage: 'Aguarde...',
      formPage: 1,
    }
    // const db = firebase.firestore()
  }

  doLogin = (cpf) => {
    this.setState({ loading: true })
    const docRef = db.collection('people').doc(cpf)
    docRef.get().then((doc) => {
      if (doc.exists) {
        console.log(doc.data())
      } else {
        console.log('Not found!')
      }
      this.setState({ loading: false })
    }).catch((err) => {
      console.log(err)
      this.setState({ loading: false })
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    // this.doLogin(this.state.cpf)
  }



  makeFormPage = () => {
    switch (this.state.formPage) {
      case 1:
        return (
          <FormPage1
            {...this.props}
            onNext={() => {
              this.setState({ formPage: 2 })
              db.collection('people').doc(this.props.formData.raw).set({ ...this.props.formData, changedAt: new Date().valueOf() })
            }}
            onPrev={() => history.replace('/')}
          />)
      case 2:
        return (
          <FormPage2
            {...this.props}
            onNext={() => {
              this.setState({ formPage: 3 })
              db.collection('people').doc(this.props.formData.raw).set({ ...this.props.formData, changedAt: new Date().valueOf() })
            }}
            onPrev={() => this.setState({ formPage: 1 })}
          />)
      case 3:
        return (
          <FormPage3
            {...this.props}
            onNext={() => {
              this.setState({ formPage: 4 })
              db.collection('people').doc(this.props.formData.raw).set({ ...this.props.formData, changedAt: new Date().valueOf() })
            }}

            onPrev={() => this.setState({ formPage: 2 })}
          />)
      case 4:
        return (
          <FormPage4
            {...this.props}
            onNext={() => {
              this.setState({ formPage: 5 })
              db.collection('people').doc(this.props.formData.raw).set({ ...this.props.formData, changedAt: new Date().valueOf() })
            }}

            onPrev={() => this.setState({ formPage: 3 })}
          />)
      case 5:
        return (
          <FormPage5
            {...this.props}
            onNext={() => {
              this.setState({ formPage: 6 })
              db.collection('people').doc(this.props.formData.raw).set({ ...this.props.formData, changedAt: new Date().valueOf() })
            }}

            onPrev={() => this.setState({ formPage: 4 })}
          />)
      case 6:
        return (
          <FormPageDone
            {...this.props}
            onPrev={() => this.setState({ formPage: 5 })}
          />
        )
      default:
        return null

    }
  }

  render() {
    // const data = this.props.formData
    return (
      <div style={{
        // backgroundColor: 'blue',
        height: '100vh',
        width: '100vw',
        justifyContent: 'center',
        alignItems: 'stretch',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
        // paddingLeft: '10%',
        // paddingRight: '10%',
      }}
      >
        <div style={{
          flex: 0,
          // alignSelf: 'stretch',
          // marginBottom: 20,
          // marginTop: 20,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 100,
          maxHeight: 100,
          // background: 'purple',
        }}>
          <a href="https://www.maniadeeventos.com.br" target="_blank" rel="noreferrer">
            <img src={logo} height={70} style={{ border: 'none', minHeight: 70, maxWidth: '100%', flex: 0, objectFit: 'contain' }} alt="Mania de Eventos" /></a>
        </div>

        <div
          style={{
            // height: '100%',
            width: '90%',
            minWidth: '80%',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            overflowY: 'auto',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            background: '#ECECEC',
            borderRadius: 20,
            marginLeft: '5%',
            marginRight: '10%',
            boxShadow: '4px 4px rgba(0,0,0,0.25)',
          }}>

          {/* <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}> */}
          {this.makeFormPage()}
          {/* </div> */}

        </div>
        <div style={{
          flex: 0, height: '100px',
          minHeight: '100px', maxHeight: '100px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          // ustify
          // padding: '32px 5%',
        }}>
          <Steps
            initial={0}
            current={this.state.formPage - 1}
            type='default'
            // size='small'
            direction='horizontal'
            style={{ width: '90%', margin: 0 }}
          >
            <Steps.Step />
            <Steps.Step />
            <Steps.Step />
            <Steps.Step />
            <Steps.Step />
          </Steps>
        </div>
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => ({
  // startLogin: (user, password) => dispatch(startLogin(user, password)),
  setForm: (data) => dispatch(setForm(data)),
  // getLots: () => dispatch(getLots()),
})

const mapStateToProps = (state) => ({
  formData: state.form,
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)
// export default LoginPage